import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4a2c5255"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "agreement-box",
  ref: "box"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "agreement-title"
}, "退款政策", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "agreement-info"
}, "众筹结束前最后1个小时无法申请退款", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "查看详情", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/md/icon/project_right_more.png"
}, null, -1));
const _hoisted_6 = [_hoisted_4, _hoisted_5];
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "agreement-title"
}, "风险提示", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "更多", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/md/icon/project_bottom_more.png"
}, null, -1));
const _hoisted_10 = [_hoisted_8, _hoisted_9];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CompRiskInfo = _resolveComponent("CompRiskInfo");
  const _component_CompRefundInfo = _resolveComponent("CompRefundInfo");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [!$data.proClassArr.includes($props.pro_class) ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_hoisted_2, _hoisted_3, _createElementVNode("div", {
    class: "more refund-info",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.onRefundInfo && $options.onRefundInfo(...args))
  }, _hoisted_6)], 64)) : _createCommentVNode("", true), _hoisted_7, _createElementVNode("div", {
    class: "agreement-info",
    ref: "riskInfo"
  }, _toDisplayString($data.riskTips), 513), _createElementVNode("div", {
    class: "more risk-info",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.onRiskInfo && $options.onRiskInfo(...args))
  }, _hoisted_10), _createVNode(_component_CompRiskInfo, {
    show: $data.show,
    "onUpdate:show": _cache[2] || (_cache[2] = $event => $data.show = $event)
  }, null, 8, ["show"]), _createVNode(_component_CompRefundInfo, {
    show: $data.showRefundInfo,
    "onUpdate:show": _cache[3] || (_cache[3] = $event => $data.showRefundInfo = $event)
  }, null, 8, ["show"])], 512);
}